import * as React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton } from '@fluentui/react';
import { ServicePosition, deleteServicePosition } from 'api/servicePosition';
import { SavingState } from 'api/savingState';
import { formStyles } from 'styles/formStyles';

interface ServicePositionDeleteProps {
    servicePosition: ServicePosition;
    onClose: (refetch: boolean) => void;
}

export const ServicePositionDelete: React.FC<ServicePositionDeleteProps> = ({ servicePosition, onClose }) => {
    const [savingState, setSavingState] = React.useState(SavingState.notChanged);

    const onDelete = () => {
        if (servicePosition && savingState !== SavingState.saving) {
            setSavingState(SavingState.saving);
            deleteServicePosition(servicePosition)
                .then(() => {
                    setSavingState(SavingState.saved);
                    onClose(true);
                })
                .catch((error) => {
                    console.error(error);
                    setSavingState(SavingState.error);
                });
        }
    };

    return (
        <Dialog
            hidden={false}
            dialogContentProps={{
                title: 'Servicesposition löschen',
                subText: 'Serviceposition "' + servicePosition.posText + '" löschen?',
                type: DialogType.normal,
            }}
        >
            {savingState === SavingState.error && <div className={formStyles.error}>Fehler beim Löschen.</div>}

            <DialogFooter>
                {savingState !== SavingState.saving && (
                    <DefaultButton
                        onClick={() => {
                            onClose(false);
                        }}
                        text="Abbrechen"
                    />
                )}

                {savingState === SavingState.saving ? (
                    <DefaultButton text="Lösche..." disabled />
                ) : (
                    <PrimaryButton
                        onClick={onDelete}
                        text="Löschen"
                        disabled={savingState !== SavingState.notChanged}
                    />
                )}
            </DialogFooter>
        </Dialog>
    );
};
